import React from 'react';
import { Link } from 'react-router-dom';
import PublicSocialLinks from './PublicSocialLinks';

function PublicPageShell({ children }) {
  return (
    <div className="demo-shell min-h-screen overflow-hidden bg-stone-950 text-stone-100">
      <div className="demo-grid pointer-events-none fixed inset-0 opacity-60" aria-hidden="true" />
      <div className="demo-glow demo-glow-one" aria-hidden="true" />
      <div className="demo-glow demo-glow-two" aria-hidden="true" />

      <div className="relative mx-auto flex min-h-screen max-w-6xl flex-col px-4 py-5 sm:px-8 sm:py-7 lg:px-10">
        <header className="flex items-center justify-between gap-4 border-b border-white/8 pb-5">
          <Link to="/" className="text-sm font-semibold uppercase tracking-[0.3em] text-amber-300">
            Zaphar
          </Link>
          <nav aria-label="Public navigation" className="flex items-center gap-5 text-sm text-stone-300">
            <Link to="/" className="transition hover:text-stone-50">Demo</Link>
            <Link to="/blog" className="transition hover:text-stone-50">Blog</Link>
          </nav>
        </header>

        <main className="flex-1">{children}</main>

        <footer className="mt-14 flex justify-center border-t border-white/8 pt-7">
          <PublicSocialLinks />
        </footer>
      </div>
    </div>
  );
}

export default PublicPageShell;
